
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.e8cad8a9.svg#" + id;
};
          